import contact_renewal from "@/modules/reminders/store/contactRenewal";
import service_reminder from "@/modules/reminders/store/serviceReminder";
import vehicle_renewal from "@/modules/reminders/store/vehicleRenewal";
import vehicle_renewal_type from "@/modules/reminders/store/vehicleRenewalType";
import contact_renewal_type from "@/modules/reminders/store/contactRenewalType";
import Repository from "@/repository";


const REMINDER_API = "/reminder";
const state = {
    reminder_data: [],
};
const getters = {
    getReminders: state => {
        return state.reminder_data
    }

};
const mutations = {
    loadAllReminders(state,payload) {
        state.reminder_data = payload.data;
    }
};
const actions = {
    async loadAllReminders({commit}) {
        try {
            commit(
                "loadAllReminders",
                await Repository.get(`${REMINDER_API}`)
            );
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
  namespaced: true,
    state,
    getters,
    mutations,
    actions,

  modules: {
    service_reminder,
    contact_renewal,
    vehicle_renewal,
    vehicle_renewal_type,
    contact_renewal_type
  }
};
